import { forwardRef, type ReactNode, type Ref } from 'react';

import cn from 'classnames';

import { Checkbox, Status } from '@wf/components';

import ItemState from '../ItemState';

import { type ListItemState } from '../../types';

import styles from './Card.module.scss';

interface ICardProps {
  title?: string | number;
  isActive: boolean;
  hasError?: boolean;
  onClick: () => void;
  statusText?: string;
  children: ReactNode;
  showCheckbox?: boolean;
  checked?: boolean;
  handleCheckboxChange?: (checked: boolean) => void;
  tag?: ReactNode;
  itemState?: ListItemState;
  dataTestId?: string;
}

function Card(
  {
    tag,
    title = '',
    isActive,
    hasError = false,
    onClick,
    statusText,
    children,
    showCheckbox = false,
    checked = false,
    handleCheckboxChange,
    itemState,
    dataTestId,
  }: ICardProps,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div
      className={cn(
        { 'bg-primary-90': isActive, 'error-border': hasError, 'primary-border': isActive },
        'p-12',
        'br-6',
        'default-border',
        'cursor',
        'grid',
        'gap-6',
        'typography-light'
      )}
      data-test-id={dataTestId}
      onClick={onClick}
      ref={ref}
    >
      {itemState && <ItemState state={itemState} />}
      <div className={styles.title}>
        {showCheckbox && (
          <Checkbox onClick={(e) => e.stopPropagation()} checked={checked} onChange={handleCheckboxChange} />
        )}
        <span className={cn('fw-semibold', 'typography')}>{title}</span>
        <Status size="sm" className={styles.status}>
          {statusText || '-'}
        </Status>
        {tag && <div className={styles.tag}>{tag}</div>}
      </div>
      {children}
    </div>
  );
}

export default forwardRef(Card);
